import { CompanyHeader } from "./components/CompanyHeader";
import { TabNavigation } from "./components/TabNavigation";
import { useEffect, useState } from "react";
import LayoutHOC from "../../../LayoutHOC";
import { useParams, useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import EditPermissionsPanel from "../AddOrganisation/components/EditPermissionPanel";
import AddMemberPanel from "../AddOrganisation/components/AddMemberPanel";
import CreateUserPanel from "../AddOrganisation/components/CreateUserPanel";
import AddGroupPanel from "../AddOrganisation/components/AddGroupPanel";
import AboutPanel from "../AddOrganisation/components/AboutPanel";
import { closeSideDrawer } from "../../../../utils/permissionSlice";
import { useDispatch } from "react-redux";
import BoardingAdvancedCompany from "./components/BoardingAdvancedCompany";
import GroupUserPermission from "./components/GroupUserPermission";
import ManageAccess from "./components/ManageAccess";
import Company from "./components/Company";

const tabs = [
  { label: "General Info", isActive: true, id: 1, component: <Company /> },
  { label: "Advanced Info", isActive: false, id: 2, component: <BoardingAdvancedCompany /> },
  { label: "Group or Users Permission", isActive: false, id: 3, component: <GroupUserPermission /> },
  { label: "Manage Access", isActive: false, id: 4, component: <ManageAccess /> },
];
export const OnboardCompany = () => {
  const { subset } = useParams();
  const [searchParams] = useSearchParams();
  const [refetch, setRefetch] = useState(false);
  const [activeTab, setActiveTab] = useState(tabs[0]);
  const companyPermission = useSelector((store) => store?.companyPermission);
  const dispatch = useDispatch();

  const handleClose = () => {
    dispatch(closeSideDrawer());
  };

  useEffect(() => {
    const urlStep = parseInt(searchParams.get("tab")) || 1;
    setActiveTab(tabs[urlStep - 1]);
  }, [searchParams]);

  return (
    <div className="flex flex-col h-full flex-wrap gap-4 p-4 bg-white">
      <div className="flex flex-col grow min-h-0">
        <CompanyHeader
          companyName="VADS Consulting Pvt. Ltd."
          logoSrc="https://api.builder.io/api/v1/image/assets/TEMP/c3d8574ca321070ad6b8608ca6e68e1d61664dd9?placeholderIfAbsent=true&apiKey=461dd38d56414be9bb1e394424980cc1"
        />
        <div className="flex grow min-h-0">
          <TabNavigation
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            refetch={refetch}
            setRefetch={setRefetch}
            handleCloseDrawer={handleClose}
          />

          {companyPermission?.key === "ADD_MEMBER" && (
            <div className="w-[33%]">
              <AddMemberPanel
                onClose={handleClose}
                groupData={companyPermission?.data}
                refetch={refetch}
                setRefetch={setRefetch}
              />
            </div>
          )}
          {companyPermission?.key === "Advanced Info" && (
            <div className="w-[33%]">
              <BoardingAdvancedCompany onClose={handleClose} />
            </div>
          )}

          {companyPermission?.key === "EDIT_PERMISSION" && (
            <div className="w-[33%]">
              <EditPermissionsPanel onClose={handleClose} groupData={companyPermission?.data} setRefetch={setRefetch} />
            </div>
          )}
          {companyPermission?.key === "CREATE_USER" && (
            <div className="w-[33%]">
              <CreateUserPanel onClose={handleClose} setRefetch={setRefetch} userData={companyPermission?.data?.data} />
            </div>
          )}
          {companyPermission?.key === "CREATE_GROUP" && (
            <div className="w-[33%]">
              <AddGroupPanel onClose={handleClose} setRefetch={setRefetch} />
            </div>
          )}
          {companyPermission?.key === "GROUP_ABOUT" && (
            <div className="w-[33%]">
              <AboutPanel onClose={handleClose} groupData={companyPermission?.data} setRefetch={setRefetch} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default OnboardCompany;
